import { z } from 'zod';
import { GlossarySettingsSchema } from './glossary';
import { AutoReplySettingsSchema } from './originator';

export const VoomaSettingsSchema = z.object({
  glossary: GlossarySettingsSchema.optional().nullable(),
  quoteAutoReply: AutoReplySettingsSchema.optional().nullable(),
});

export type VoomaSettings = z.infer<typeof VoomaSettingsSchema>;

export enum SettingsHierarchyLevel {
  USER = 'USER',
  TEAM = 'TEAM',
  ORIGINATOR = 'ORIGINATOR',
  ORGANIZATION = 'ORGANIZATION',
  GLOBAL = 'GLOBAL',
}
